import { NavItemType } from "../Navigation.d"

export const addNodeChild = (
    nodes: NavItemType[],
    newItem: NavItemType,
    key: string | number
): NavItemType[] => {
    let _nodes = nodes

    for (const n in nodes) {
        const thisItem = nodes[n]
        if (thisItem.key === key) {
            if (thisItem.children) {
                _nodes[n] = {
                    ...thisItem,
                    children: [
                        ...thisItem.children,
                        newItem,
                    ],
                }
            } else {
                _nodes[n] = {
                    ...thisItem,
                    children: [newItem],
                }
            }
        } else {
            if (thisItem.children) {
                _nodes[n] = {
                    ...thisItem,
                    children: addNodeChild(
                        thisItem.children,
                        newItem,
                        key
                    ),
                }
            }
        }
    }

    return _nodes
}

export const editNodeChild = (
    nodes: NavItemType[],
    editedItem: NavItemType,
): NavItemType[] => {
    let _nodes = nodes

    for (const n in nodes) {
        const thisItem = nodes[n]
        if (thisItem.key === editedItem.key) {
            _nodes[n] = {
                ...thisItem,
                ...editedItem,
            }
        } else {
            if (thisItem.children) {
                _nodes[n] = {
                    ...thisItem,
                    children: editNodeChild(
                        thisItem.children,
                        editedItem,
                    ),
                }
            }
        }
    }

    return _nodes
}